/**
 * Student Resources page (/portal/resources): browse + download only.
 */
import PortalPageHeader from "../../components/portal/PortalPageHeader";
import ResourceBrowser from "../../components/resources/ResourceBrowser";

export default function PortalResources() {
  return (
    <div data-testid="portal-resources-page" className="space-y-10">
      <PortalPageHeader
        kickerKey="portal.placeholder.kicker"
        titleKey="portal.nav.resources"
        subtitleKey="portal.pages.resources_desc"
      />
      <ResourceBrowser mode="read" />
    </div>
  );
}
